import React from 'react';
import './TextPreview.scss';

const TextPreview = props => {
	const { from, item, margin } = props;

	const fromButton = from === 'WidgetButton';
	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Text</div>}
				{fromButton ? (
					<div className="text-preview">
						<div className="line" />
						<div className="line" />
						<div className="line three" />
					</div>
				) : (
					<div style={{ margin, minHeight: '40px' }}>
						<p dangerouslySetInnerHTML={{ __html: item.props.text }} />
					</div>
				)}
			</div>
		</div>
	);
};

export default TextPreview;
